import React from "react";
import Card from "react-bootstrap/Card";

const Certifications = () => {
  return (
    <div className="certifications">
      <div className="cert-card">
        <Card>
          <Card.Header className="cert-card-header">
            Certifications and Licenses
          </Card.Header>
          <Card.Body>
            <Card.Text>
              <ul>
                <li>Linux Essentials Certificate (2026)</li>
                <li>ITIL 4 Foundation Certificate in IT Service Management (2025)</li>
              </ul>
            </Card.Text>
          </Card.Body>
        </Card>
      </div>
    </div>
  );
};

export default Certifications;